import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { AttributeLegend } from '../../../../subcomponents/attribute-legend/attribute-legend';
import { getShowtimeAttributes } from '../../../../subcomponents/attribute-list/utils';
const b = bemClassBuilder('v-showtime-summary-attribute-legend');
export const ShowtimeSummaryAttributeLegend = observer(props => {
    const { showtime, iconCdnOptions, displayText, config } = props;
    const { attributeFilterFn, showLabel } = config;
    const attributes = getShowtimeAttributes([showtime]);
    const filteredAttributes = attributeFilterFn ? attributeFilterFn(attributes) : attributes;
    if (!filteredAttributes.length)
        return null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(AttributeLegend, { heading: displayText.attributeLegendLabel, showLabel: !!showLabel, attributes: filteredAttributes, viewLegendButtonLabel: displayText.attributeLegendViewButtonLabel, modalHelpText: displayText.attributeLegendModalHelpText, iconCdnOptions: iconCdnOptions }) })));
});
ShowtimeSummaryAttributeLegend.displayName = 'ShowtimeSummaryAttributeLegend';
